import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SegmentComponent} from './segment/segment.component';
import {HomeComponent} from './home/home.component';
import {SegmentProductsComponent} from './segment/segment-products/segment-products.component';
import {SegmentDetailsComponent} from './segment/segment-details/segment-details.component';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'segment/:transport', component: SegmentComponent},
  {path: 'segment/:transport/:zone', component: SegmentProductsComponent},
  {path: 'segment/:transport/:zone/:product', component: SegmentDetailsComponent},
  {path: '**', component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
